import request from '@/request/request'

// 查询设备列表
export function listOperationLog(query) {
    return request({
        url: '/api/system-server/operationLog/list',
        method: 'get',
        params: query
    })
}
// 查询设备列表
export function loginLog(query) {
    return request({
        url: '/api/auth-server/logininfor/list',
        method: 'get',
        params: query
    })
}